module.exports = __webpack_public_path__ + "dingbeauty-landing/img/formdevice_v2@2x.212933b1.png";